import { getDefaultReportQueryParams, PAYMENT_RECEIVE_FILTER_KEY } from "../paymentReportFilterDefaults";

export const defaultSorted = [{ dataField: "id", order: "asc" }];

export const initialFilter = {
  page: 1,
  page_size: 20,
  sortBy: "created_at",
  sortOrder: "descend",
};

/**
 * Resolved on every mount (not once at import) so a filter saved in a previous visit is picked up.
 * The default payment status / channel are seeded here because the export reads `queryParams`
 * directly — without them the export would go out unfiltered while the popover shows filters.
 */
export const getInitialFilter = () => ({
  ...initialFilter,
  ...getDefaultReportQueryParams(PAYMENT_RECEIVE_FILTER_KEY),
});
